const styles = () => ({
  searchBar: {
    display: 'flex',
    padding: '10px 25px',
    justifyContent: 'space-between',
    borderBottom: '1px solid #d9d9d9',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/account/businesses/Businesses/List/SearchParams/styles.js